<div class="">
    <div class="flex justify-content-between align-items-center mb-4">
        <div class="flex align-items-center gap-3">
            <input type="text" pInputText placeholder="Search patients..." [formControl]="searchControl"
                class="w-20rem" />
        </div>
    </div>

    <!-- Sorting Controls -->
    <div class="flex flex-wrap gap-2 mb-4 p-3 border-round surface-border border-1">
        <div class="flex align-items-center gap-2">
            <span class="text-sm font-medium">Sort by:</span>
        </div>
        <button pButton class="p-button-outlined p-button-sm"
            [class.p-button-secondary]="pageOptions.orderBy === 'firstName'" (click)="onCardSort('firstName')">
            First Name
            <i class="pi ml-1" [ngClass]="pageOptions.orderBy === 'firstName' ? 
                         (pageOptions.orderDir === OrderDir.ASC ? 'pi-sort-up' : 'pi-sort-down') : 
                         'pi-sort'"></i>
        </button>
        <button pButton class="p-button-outlined p-button-sm"
            [class.p-button-secondary]="pageOptions.orderBy === 'lastName'" (click)="onCardSort('lastName')">
            Last Name
            <i class="pi ml-1" [ngClass]="pageOptions.orderBy === 'lastName' ? 
                         (pageOptions.orderDir === OrderDir.ASC ? 'pi-sort-up' : 'pi-sort-down') : 
                         'pi-sort'"></i>
        </button>
        <button pButton class="p-button-outlined p-button-sm"
            [class.p-button-secondary]="pageOptions.orderBy === 'dateOfBirth'" (click)="onCardSort('dateOfBirth')">
            Date of Birth
            <i class="pi ml-1" [ngClass]="pageOptions.orderBy === 'dateOfBirth' ? 
                         (pageOptions.orderDir === OrderDir.ASC ? 'pi-sort-up' : 'pi-sort-down') : 
                         'pi-sort'"></i>
        </button>
        <button pButton class="p-button-outlined p-button-sm"
            [class.p-button-secondary]="pageOptions.orderBy === 'createdAt'" (click)="onCardSort('createdAt')">
            Created
            <i class="pi ml-1" [ngClass]="pageOptions.orderBy === 'createdAt' ? 
                         (pageOptions.orderDir === OrderDir.ASC ? 'pi-sort-up' : 'pi-sort-down') : 
                         'pi-sort'"></i>
        </button>
    </div>

    <!-- Cards Grid -->
    <div class="flex flex-column gap-4" *ngIf="patientPage.data && patientPage.data.length > 0">
        <div class="surface-card border-round-xl shadow-2 p-4 cursor-pointer hover:shadow-4 hover:border-teal-300 hover:bg-teal-50 transition-all transition-duration-200"
            *ngFor="let patient of patientPage.data" (click)="viewPatient(patient.id)">
            <div class="flex align-items-center gap-4">
                <!-- Patient Icon -->
                <div class="flex align-items-center justify-content-center w-4rem h-4rem border-round-lg surface-100">
                    <i class="pi pi-user text-3xl text-primary"></i>
                </div>

                <!-- Patient Details -->
                <div class="flex-1 flex flex-column gap-2">
                    <!-- Header with Name -->
                    <div class="flex justify-content-between align-items-start">
                        <div class="flex flex-column gap-1 flex-1">
                            <div class="flex align-items-center gap-2">
                                <h3 class="m-0 text-xl font-semibold text-900">
                                    {{ patient.title }} {{ patient.firstName }} {{ patient.lastName }}
                                </h3>
                            </div>
                            <small class="text-600 font-mono">ID: {{ patient.id }}</small>
                            <small class="text-600" *ngIf="patient.email">{{ patient.email }}</small>
                        </div>
                    </div>

                    <!-- Patient Meta Info -->
                    <div class="flex align-items-center gap-6 text-sm text-600">
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-calendar"></i>
                            <span>{{ patient.dateOfBirth | dynamicDate:'shortDate' }}</span>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-clock"></i>
                            <span>Age {{ getAge(patient.dateOfBirth) }}</span>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-users"></i>
                            <span>{{ patient.sex.displayName }}</span>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-calendar-plus"></i>
                            <span>{{ patient.createdAt | dynamicDate:'shortDate' }}</span>
                        </div>
                    </div>
                </div>

                <!-- Actions -->
                <app-patient-actions-menu [orgId]="orgId" patientId={{patient.id}} (menuEvent)="onMenuEvent($event)">
                </app-patient-actions-menu>
            </div>
        </div>
    </div>

    <!-- Empty State -->
    <div class="text-center py-8" *ngIf="!patientPage.data || patientPage.data.length === 0">
        <div class="flex flex-column align-items-center gap-3">
            <i class="pi pi-users text-6xl text-400"></i>
            <h3 class="text-500 m-0">No patients found</h3>
            <p class="text-500 m-0">Try adjusting your search</p>
        </div>
    </div>

    <!-- Pagination -->
    <div class="flex justify-content-center mt-4" *ngIf="patientPage.data && patientPage.data.length > 0">
        <p-paginator [rows]="pageOptions.limit" [totalRecords]="patientPage.total"
            [first]="(pageOptions.page - 1) * pageOptions.limit" (onPageChange)="onPaginatorPageEvent($event)"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} patients">
        </p-paginator>
    </div>


    <!-- Migration Popup -->
    @if (showMigrationPopup) {
        <app-patients-migrate (dialogShouldClose)="closeMigrationDialog()" [orgId]="orgId"></app-patients-migrate>
    }


</div>